import React from 'react';

// Themed empty state for the nemonto list screens - replaces the generic
// gray NoDataFound placeholder image, which read as legacy admin chrome
// next to the spice/cream card styling.
const EmptyState = ({ icon = 'inbox', title, sub }) => (
  <div className="nmsl-empty-state">
    <span className="material-symbols-outlined nmsl-empty-icon">{icon}</span>
    <p className="nmsl-empty-title">{title}</p>
    {sub && <p className="nmsl-empty-sub">{sub}</p>}
  </div>
);

export default EmptyState;
